import { useState } from 'react'
import styled from '@emotion/styled'
import { SimpleReadingListBatchValidateResEntry } from 'stylewhere/api'
import { Box, EntryListModal, SmallTextCounter } from 'stylewhere/components'
import { T, __ } from 'stylewhere/i18n'
import { SimpleReadingListOperationConfig } from 'stylewhere/shared'

type Props = {
  entries: SimpleReadingListBatchValidateResEntry[]
  operation?: SimpleReadingListOperationConfig
}

export const EntryReadingCounters: React.FC<Props> = ({ entries, operation }) => {
  const [modalVisible, setModalVisible] = useState<false | 'error' | 'warning' | 'ignored' | 'ignoredWithReason'>(false)
  const errorItems = entries.filter((itm) => itm.status === 'error')
  const warningItems = entries.filter((itm) => itm.status === 'warning')
  const ignoredItems = entries.filter((itm) => itm.status === 'ignored')
  const ignoredWithReasonItems = entries.filter((itm) => itm.status === 'ignoredWithReason')

  let modalTitle = ''
  if (modalVisible === 'error') {
    modalTitle = __(T.fields.error_items)
  }
  if (modalVisible === 'warning') modalTitle = __(T.fields.warning_items)
  if (modalVisible === 'ignored') modalTitle = __(T.fields.ignored_items)
  if (modalVisible === 'ignoredWithReason') modalTitle = __(T.fields.ignored_items)
  return (
    <Container style={{ flexWrap: 'wrap', gap: 12 }} row justify="space-evenly">
      {errorItems.length > 0 && (
        <SmallTextCounter
          counter={errorItems.length}
          title={__(T.error.error)}
          status="error"
          onClick={() => setModalVisible('error')}
        />
      )}
      {warningItems.length > 0 && (
        <SmallTextCounter
          counter={warningItems.length}
          title={__(T.misc.warning)}
          status="warning"
          onClick={() => setModalVisible('warning')}
        />
      )}
      {ignoredItems.length > 0 && (
        <SmallTextCounter
          counter={ignoredItems.length}
          title={__(T.misc.ignored)}
          status="ignored"
          onClick={() => setModalVisible('ignored')}
        />
      )}
      {ignoredWithReasonItems.length > 0 && (
        <SmallTextCounter
          counter={ignoredWithReasonItems.length}
          title={__(T.misc.ignored_with_reason)}
          status="ignoredWithReason"
          onClick={() => setModalVisible('ignoredWithReason')}
        />
      )}

      {modalVisible === 'error' && (
        <EntryListModal
          entries={errorItems}
          operation={operation}
          isOpen
          onClose={() => setModalVisible(false)}
          title={modalTitle}
        />
      )}
      {modalVisible === 'warning' && (
        <EntryListModal
          entries={warningItems}
          operation={operation}
          isOpen
          onClose={() => setModalVisible(false)}
          title={modalTitle}
        />
      )}
      {modalVisible === 'ignored' && (
        <EntryListModal
          entries={ignoredItems}
          operation={operation}
          isOpen
          onClose={() => setModalVisible(false)}
          title={modalTitle}
        />
      )}
      {modalVisible === 'ignoredWithReason' && (
        <EntryListModal
          entries={ignoredWithReasonItems}
          operation={operation}
          isOpen
          onClose={() => setModalVisible(false)}
          title={modalTitle}
        />
      )}
    </Container>
  )
}

const Container = styled(Box)``
